import Slider from "@mui/material/Slider";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import DatePicker from "react-datepicker";
import { ThemeProvider } from '@mui/material/styles';

import "react-datepicker/dist/react-datepicker.css";

// The mapping stage component contains some button(s)/slider(s) to change the way the data is displayed.
// It has access to these parameters through functions that are passed to it from the main page.
export default function MappingStage({heatData, dataSetsDomain, setStrokeWidth, domain, setDomain, selectedDay, setSelectedDay, chartType, setChartType, theme}) {
  const onChangeChart = (event) => {
    setChartType(event.target.value);
    setSelectedDay(new Date(dataSetsDomain[0]));
  }

  const DatePickerWidget = () => {
    let startDate = null;
    let endDate = null;
    if (dataSetsDomain !== ["auto","auto"]) {
      startDate = new Date(dataSetsDomain[0]);
      endDate = new Date(dataSetsDomain[1]);
    }
    return (
      <div style={{ flexDirection: "column" }}>
        Select date
        <div style={{ display: "flex", justifyContent: "center" }}>
          <DatePicker 
            minDate={startDate}
            maxDate={endDate}
            selected={selectedDay}
            onChange={(date) => setSelectedDay(date)}
            inline
          />
        </div>
      </div>
    );
  };

  function thicknessText() {
    return chartType === "Line" ? "Line Thickness" : "Dot Thickness";
  } 

  return (
    <div style={{ margin: "0 1em", display: "flex", flexDirection: "column" }}>
        <ThemeProvider theme={ theme }>
        {thicknessText()}
        <Slider
          defaultValue={1}
          onChange={(event) => setStrokeWidth(event.target.value)}
          valueLabelDisplay="auto"
          disabled={heatData[0].length <= 0 && heatData[1].length <= 0}
          color="main"
          step={1}
          marks
          min={1}
          max={5}
        />
        Select date/time range
        <Slider
          value={domain}
          onChange={(event, data) => setDomain(data)}
          color="main"
          valueLabelDisplay="auto"
          disabled={(heatData[0].length <= 0 && heatData[1].length <= 0) || chartType === "Scatter"}
        />
        {chartType === "Scatter" && <DatePickerWidget />}
        <div style={{ justifyContent: "center" }}>
          <ToggleButtonGroup
            color="main"
            value={chartType}
            exclusive
            disabled={heatData[0].length <= 0 && heatData[1].length <= 0}
            onChange={onChangeChart}
          >
            <ToggleButton value="Line">Line</ToggleButton>
            <ToggleButton value="Scatter">Scatter</ToggleButton>
            <ToggleButton value="Span">Span</ToggleButton>
          </ToggleButtonGroup>
        </div>
        </ThemeProvider>
    </div>
  );
}